export default async function initFastlane(targetEnv, geoLocOverride) {
  try {
    if (!window.paypal.Fastlane) {
      throw new Error('PayPal script loaded but no Fastlane module');
    }

    if (targetEnv === 'development' || targetEnv === 'staging') {
      window.localStorage.setItem('axoEnv', 'stage');
      window.localStorage.setItem('axoPortalUrl', 'https://www.msmaster.qa.paypal.com/');
    }

    const styles = {
      root: {
        backgroundColor: '#faf8f5'
      }
    };

    const {
      identity,
      profile,
      FastlanePaymentComponent, // used for quick start integration
      FastlaneCardComponent, // used for flexible integration
      FastlaneWatermarkComponent
    } = await window.paypal.Fastlane({
      metadata: { geoLocOverride },
      styles
    });

    (
      await FastlaneWatermarkComponent({
        includeAdditionalInfo: true
      })
    ).render('#watermark-container');

    const paymentWatermark = await FastlaneWatermarkComponent({});

    const cardComponent = await FastlaneCardComponent();
    const paymentComponent = await FastlanePaymentComponent();
    // return both flexible and quick start components in case user switches on client-side and because of limitation with SDK
    return {
      paymentWatermark,
      paymentComponent,
      cardComponent,
      identity,
      profile
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return {
      error
    };
  }
}
